import {createFileRoute} from '@tanstack/react-router';

import {layerTemplateKeys} from '@/features/Library/api/queryKeys';
import {getLayerTemplate} from '@/features/Library/api/readLayerTemplate';
import {UpdateLayerTemplateForm} from '@/features/Library/components/Location/UpdateLayerTemplateForm';
import {makeDocumentTitle} from '@/utils/makeDocumentTitle';

export const Route = createFileRoute(
  '/_b/_p/_library/locations_/$layoutTemplateId/update/$layerTemplateId'
)({
  component: UpdateLayerTemplateForm,

  beforeLoad: ({params, context}) => {
    makeDocumentTitle(params.layerTemplateId);

    return {
      ...context,
      readLayerTemplateQuery: {
        queryKey: layerTemplateKeys.detail(params.layerTemplateId),
        queryFn: () => getLayerTemplate(params.layerTemplateId),
      },
    };
  },

  loader({context}) {
    return context.queryClient.ensureQueryData(context.readLayerTemplateQuery);
  },
});
